import script from "./AddAiNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAiNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./AddAiNoteForm.vue?vue&type=style&index=0&id=b59d9ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b59d9ccc"]])

export default __exports__